export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/shopify.1c75815.svg";